// extracted by mini-css-extract-plugin
module.exports = {"contrastedText":"styles_contrastedText__MN5TW","orderSummary":"styles_orderSummary__fWkfv"};